<template>
    <div id="app">
        <el-container class="flextext">
            <home-head></home-head>
            <el-main class="neitong_bufen_qiangzhi">
                <div class="content">
                    <el-tag closable v-if="js_zhi" @close="juese_sc_sj()">{{js_zhi.title}}</el-tag>
                    <el-tag closable v-if="bujian" @close="bujian_sc_sj()" style="margin-left: 20px">{{bujian}}</el-tag>
                    <el-tag closable v-if="ly_zhi" @close="lingyu_sc_sj()" style="margin-left: 20px">{{ly_zhi.key}}
                    </el-tag>
                    <el-tag closable v-if="type==1" @close="lingyu_sc_sj2()" style="margin-left: 20px">个人</el-tag>
                    <el-tag closable v-if="type==2" @close="lingyu_sc_sj2()" style="margin-left: 20px">企业</el-tag>
                    <el-tag closable v-if="type==3" @close="lingyu_sc_sj2()" style="margin-left: 20px">实验室</el-tag>
                    <!-- <div class="main-heads">
                        <div style="width: 95%; margin: 10px auto">
                            <div class="search-tops">检验分类：</div>
                            <el-row class="search_tops_el_row">
                                
                                <el-col :xs="8" :sm="6" :md="4" v-for="(item1,index) in yingyong_ly" :key="index">
                                    <a class="a_color" v-if="item1.position==1" @click="lingyu_sj(item1)"
                                       :title="item1.title">
                                        <div class="search-tops-title" id="showLabelAndAttrName">{{ item1.key }}
                                        </div>
                                    </a>
                                </el-col>
                            </el-row>
                        </div>
                    </div> -->
                    <div class="main-head">
                        <el-row>
                            
                            <el-col :xs="8" :sm="6" :md="4" style="width: 300px">
                                <div class="search-top">选择分类：
                                    <el-cascader
                                        size="medium"
                                        filterable='true'
                                        clearable='true'
                                        v-model="value"
                                        :options="wiki_brand_category"
                                        :props="{value:'title',
                                         label:'title',
                                        //  checkStrictly:true,
                                         expandTrigger:'hover',
                                         
                                         }"
                                        @change="checkWikiBrandCategory">
                                    </el-cascader>
                                </div>
                            </el-col>
                            
                            <el-col :xs="8" :sm="6" :md="4" style="margin-left: 100px">
                                <div class="jiance_sousuo">
                                <el-input
                                        style="margin-top: 2px;color: #c60000;
                                          border: 1px solid #c60000;border-radius: 5px;width:135px;"
                                          size="mini"
                                          placeholder="请输入内容"
                                          v-model="wiki_search_key"
                                          class="xuanze"

                                          >
                                </el-input>
                              <el-button type="danger"
                                         size="mini"
                                         style="position: relative;left: -5px;height: 30px;width: 60px "
                                         @click="do_wiki_search">搜索
                              </el-button>
                                </div>

                            </el-col>
                        </el-row>
                    </div>
                    <div style="width: 70%;float: left;">
                        <el-row :gutter="35" style="margin-top: 20px;">
                            <el-col :xs="24" :sm="24" :md="24" v-for="(item,index) in wiki_product_list" :key="index">
                                <div class="shebei-item" style="width: 100%;">
                                    <!-- <a :href="'#/wiki/detail/' + item.id" > -->
                                        <div class="backgd" style="text-align: left">
                                            <div style="width: 40%;float: left;margin-top: 35px;">
                                                <a :href="'#/wiki/detail/' + item.id" >
                                                <el-image :src="item.source_img" fit="cover"
                                                          style="margin-left: 20px">
                                                    <div slot="error" class="image-slot">
                                                        <img src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png"
                                                             alt=""
                                                             style="height: 220px">
                                                    </div>
                                                </el-image>
                                            </a>
                                            </div>
                                            <div style="width: 60%;float: left;">
                                                <div style="height: 21px;margin-top: 60px;font-size: 20px">
                                                    <a :href="'#/wiki/detail/' + item.id" >
                                                        <p class="prices">{{item.title}}</p>
                                                    </a>
                                                </div>
                                                
                                                <div style="height: 21px;margin-top: 50px;margin-left: 30px">
                                                    <dl style="display:flex; font-size:14px; margin:10px 0">
                                                        <dt style="width:60px;font-weight:bold">品牌：</dt>
                                                        <dd>{{item.brand}}</dd>
                                                    </dl>
                                                    <dl style="display:flex; font-size:14px;">
                                                        <dt style="width:60px;font-weight:bold">分类：</dt>
                                                        <dd>{{item.category}}</dd>
                                                    </dl>

                                                </div>
                                            </div>
                                        </div>
                                    <!-- </a> -->
                                    <el-dialog title="基本信息" :visible.sync="dialogFormVisible">
                                        <el-form :model="dynamicValidateForm" ref="dynamicValidateForm"
                                                 label-width="151px"
                                                 class="demo-dynamic">
                                            <input name="_csrf_token" type="hidden"
                                                   value="5a7b09fb916b5f1cc5206a73d2716696">
                                            <input type="hidden" name="action" value="memberProfileAction">
                                            <input type="hidden" name="event_submit_do_modifyBaseInfo" value="anywhere">
                                            <input type="hidden" name="superviseCheck" value="false">
                                            <div class="tab-main">
                                                <div class="fieldline fd-clr ">
                                                    <el-form-item label="头像上传" prop="头像上传">
                                                        <el-upload
                                                                class="avatar-uploader"
                                                                :show-file-list="false"
                                                                :on-success="handleAvatarSuccess"
                                                                :before-upload="beforeAvatarUpload">
                                                            <img v-if="dynamicValidateForm.fengmian"
                                                                 :src="dynamicValidateForm.fengmian"
                                                                 class="avatar" style="width: 200px">
                                                            <i v-else class="el-icon-picture-outline"></i>
                                                        </el-upload>
                                                    </el-form-item>
                                                </div>
                                                <div class="fieldline fd-clr ">
                                                    <el-form-item label="用户名" prop="name">
                                                        <el-input v-if="weixin_zt===false"
                                                                  v-model="dynamicValidateForm.name" size="mini"
                                                                  style="width: 230px"></el-input>
                                                        <el-input v-if="weixin_zt===true"
                                                                  v-model="dynamicValidateForm.name" size="mini"
                                                                  style="width: 230px" :disabled="true"></el-input>
                                                    </el-form-item>
                                                </div>
                                                <div class="fieldline fd-clr ">
                                                    <el-form-item label="手机号" prop="phone">
                                                        <el-input :disabled="true" v-model="dynamicValidateForm.phone"
                                                                  size="mini"
                                                                  style="width: 230px"></el-input>
                                                    </el-form-item>
                                                </div>
                                                <div class="fieldline fd-clr ">
                                                    <el-form-item label="微信" prop="wchat">
                                                        <el-input v-model="dynamicValidateForm.wchat" size="mini"
                                                                  style="width: 230px" :disabled="true"></el-input>
                                                    </el-form-item>
                                                </div>
                                                <div class="fieldline fd-clr ">
                                                    <el-form-item label="QQ" prop="qq">
                                                        <el-input v-model="dynamicValidateForm.qq" size="mini"
                                                                  style="width: 230px" :disabled="true"></el-input>
                                                    </el-form-item>
                                                </div>
                                                
                                                <div class="fieldline fd-clr ">
                                                    <el-form-item
                                                            prop="email"
                                                            label="邮箱："
                                                    >
                                                        <el-input v-model="dynamicValidateForm.email" size="mini"
                                                                  style="width: 230px" :disabled="true"></el-input>
                                                    </el-form-item>
                                                </div>

                                                <div class="submit-wrapper fd-clr">
                                                   
                                                </div>
                                            </div>
                                        </el-form>

                                    </el-dialog>
                                    
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="width: 25%;float: left;margin-left: 5%">
                        <div style="line-height: 50px;font-size: 20px">推荐商品</div>
                        <div v-for="(item,index) in block_item" v-bind:key="index">
                            <a :href="'#/dianpu_index/'+item.object.id">
                                <div v-if="item.object_type=='goods'"
                                     style="background: #ffffff;width: 100%;height: 340px;">

                                    <div slot="error" class="image-slot" style="width: 100%;">
                                        <img :src="url+'/storage/'+item.object.cover" alt=""
                                             style="width: 100%;height: 220px">
                                        <!--                        <i class="el-icon-picture-outline"></i>-->
                                        <div style="color: #333333;font-size: 14px;margin-left: 20px">
                                            {{item.object.title}}
                                        </div>
                                        <!--                  <div class="haopin" style="color: #999999;font-size: 14px;margin-top: 10px">浏览量   2300  人</div>-->
                                        <div v-if="item.object.cash=='0.00'"
                                             style="margin-top: 15px;color: #d0320a;font-size: 16px;margin-left: 20px">
                                            {{item.object.price_yugu}}
                                        </div>
                                        <div v-if="item.object.cash!=='0.00'"
                                             style="margin-top: 15px;color: #d0320a;font-size: 16px;margin-left: 20px">
                                            {{item.object.cash}}
                                        </div>
                                    </div>

                                </div>
                            </a>
                        </div>
                        <div style="line-height: 50px;font-size: 20px">推荐服务</div>

                        <div v-for="(item,index) in block_item" v-bind:key="index">
                            <a :href="'#/dianpu_details/'+item.object.id">
                                <div v-if="item.object_type=='fuwu'"
                                     style="background: #ffffff;width: 100%;height: 340px;">

                                    <div slot="error" class="image-slot" style="width: 100%;">
                                        <img :src="url+'/storage/'+item.object.cover" alt=""
                                             style="width: 100%;height: 220px">
                                        <!--                        <i class="el-icon-picture-outline"></i>-->
                                        <div style="color: #333333;font-size: 14px;margin-left: 20px">
                                            {{item.object.title}}
                                        </div>
                                        <!--                  <div class="haopin" style="color: #999999;font-size: 14px;margin-top: 10px">浏览量   2300  人</div>-->
                                        <div style="margin-top: 15px;color: #d0320a;font-size: 16px;margin-left: 20px">
                                            {{item.object.price_yugu}}
                                        </div>

                                    </div>

                                </div>
                            </a>
                        </div>

                    </div>


                    <div data-v-6af373ef="" data-v-5c2776a4="" class="pagination-container"
                         style="line-height: 5.1em;margin-top: 60px;width: 100%">
                        <div data-v-6af373ef="" class="el-pagination is-background">
                            <span class="el-pagination__total">共 {{ zuoshuL }} 条</span>
                            <el-pagination
                                    style="float: left"
                                    layout="prev, pager, next"
                                    @current-change="yedianji"
                                    :total="zuidayema*10">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </el-main>
            <footerall></footerall>
        </el-container>
    </div>
</template>
<script>
    import home_head from '../../common/home-head';
    import {regionDataPlus} from 'element-china-area-data'
    import footerall from "../../common/footer";

    export default  {

        name: "category",
        

        data: function () {
            return {
                url_pre: '',
                design_block: [],
                brand_list: [],
                tab: '',
                weixin_zt: true,
                fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
                dialogTableVisible: false,
                dialogFormVisible: false,
                dynamicValidateForm: {
                    fengmian: '',
                    fengmian_pic: '',
                    domains: [{
                        value: ''
                    }],
                    email: '',
                    name: '',
                    phone: '',
                    wchat: '',
                    qq: '',
                },
                formLabelWidth: '120px',
                is_open: {
                    sousuo: 1,
                    lanmu: 1,
                    phone_shaixuan: 0,
                    phone_sousuokuang: 0,
                },
                activeIndex: '1',
                activeIndex2: '1',
                input2: '',
                options: regionDataPlus,
                selectedOptions: [],
                list: '',
                lists: '',
                list_guige: [],
                url: '',
                zuoshuL: '',
                zuidayema: '',
                diqu: '',
                is_open2: 1,
                is_open3: 1,
                checked: false,
                pidzhi: 0,
                gongyelian: '',
                lingbujian: '',
                bujian: '',
                gylian: '',
                biaoqain_name: '',
                yingyong_ly: '',
                ly_zhi: '',
                js_zhi: '',
                information: '',
                qy_juese: '',
                type: '',
                block_item: '',

                wiki_brand_name:'',         // 品牌名称
                wiki_brand:null,            // 品牌
                wiki_brand_category:null,   // 品牌分类
                wiki_checked_category:'',   // 选择的品牌分类
                wiki_search_key:'',         // 搜索关键字
                wiki_product_list:[],       // 产品列表

            }
        },
        components: {
            'home-head': home_head,
            footerall
        },
        methods: {
            Exhabit(item) {
                console.log(item)
                this.dialogFormVisible = true;
                this.name = item.name;
                this.avatar = item.avatar;
                this.email = item.email;
                this.phone = item.mobile;
                this.wchat = item.wechat;
                this.qq = item.qq;
            },
            sousuo_xuanxiang(e) {
                this.is_open.sousuo = e
                console.log(this.is_open.sousuo)
            },
            init() {
                this.information = this.$store.state.information
                this.list_data()
                this.data2()
                this.get_design_block();
                this.get_brand_list();
                this.lingyu()
                
                this.url = window.config.api_url

                // todo 本页面 代码 开始

                // todo 获取 路由参数

                this.wiki_brand_name = this.$route.params.brand_name;
                this.wiki_search_key = typeof this.$route.params.key != 'undefined' ? this.$route.params.key : '';
                
                // todo 获取 （百科）品牌， 根据品牌名称
                this.get_wiki_brand();
                // todo 获取 （百科）品牌下分类列表
                // this.get_wiki_brand_category();
                
            },

            get_wiki_brand: function () {

                var t = this
                var url = window.config.api_url + '/college/wiki/brand' + '?title=' + this.wiki_brand_name ;
                t.axios.get(url).then(res => {

                    t.wiki_brand = res.data[0];
                    t.wiki_brand_category = t.wiki_brand.category;
                    
                    // todo 获取 （百科）品牌下产品列表
                    t.do_wiki_search();
                })

            },

            do_wiki_search: function(){

                var t = this
                var url = window.config.api_url + '/college/wiki/search';
                url += '?brand_id=' + t.wiki_brand.id;
                if( t.wiki_checked_category){
                    url += '&category=' + t.wiki_checked_category;
                }
                
                url += '&keyword=' + t.wiki_search_key;

                t.axios.get(url).then(res => {

                    t.wiki_product_list = res.data.data;
                })

            },

            checkWikiBrandCategory:function( item ){

                // console.log ( item )
                this.wiki_checked_category = item[ item.length - 1 ];
            },

            get_brand_list: function () {

                var t = this
                var url = window.config.api_url + '/college/home/brand/list' + '?position=yibingyijiang'
                t.axios.get(url).then(res => {

                    t.brand_list = res.data;
                })

            },

            get_design_block: function () {

                var t = this
                var url = window.config.api_url + '/college/block/shangpin/list' + '?position=jianyanjiance'
                t.axios.get(url).then(res => {

                    t.design_block = res.data;
                    for (let i = 0; i <= this.design_block.length; i++) {
                        this.block_item = this.design_block[i].block_item
                    }
                    t.design_block.forEach(res => {
                        res.keywords = Array.isArray(res.keywords)
                            ? res.keywords
                            : res.keywords.split(',');
                    })
                })

            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        alert('submit!');
                        
                    }
                    
                });
            },
            handleAvatarSuccess(res, file) {//资质
                this.dynamicValidateForm.fengmian = URL.createObjectURL(file.raw);
            },
            beforeAvatarUpload(file) {//企业执照
                var t = this
                var id = localStorage.getItem("uid")
                const isJPG = file.type === 'image/jpeg';
                const isPNG = file.type === 'image/png';
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG && !isPNG) {
                    return this.$message.error('上传头像图片只能是 JPG 或者png格式!');
                }
                if (!isLt2M) {
                    return this.$message.error('上传头像图片大小不能超过 2MB!');
                }
                let url = window.URL || window.webkitURL;

                this.dynamicValidateForm.fengmian = url.createObjectURL(file);
                var formData = new FormData();
                formData.append('file', file);
                formData.append('token', id);
                var post_url = window.config.api_url + '/user/uploadImg';
                this.axios.post(post_url, formData).then(function (res) {
                    // console.log( res );
                    t.dynamicValidateForm.fengmian_pic = res.data.path
                });
                // t.dynamicValidateForm.fengmian_pic = file
                return isJPG && isLt2M;
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            data2() {

                var t = this
                var id = localStorage.getItem("uid")
                var url = window.config.api_url + '/user/info?token=' + id
                this.axios
                    .get(url)
                    .then(function (res) {
                        
                        var r = res.data
                        
                        t.dynamicValidateForm.name = r.name
                        if (t.dynamicValidateForm.name.slice(0, 3) == 'wx-') {
                            t.weixin_zt = false
                        }
                        t.dynamicValidateForm.phone = r.mobile
                        t.dynamicValidateForm.qq = r.qq
                        t.dynamicValidateForm.wchat = r.wechat
                        t.dynamicValidateForm.email = r.email
                        t.dynamicValidateForm.fengmian = window.config.api_url + '/storage/' + r.avatar
                        t.dynamicValidateForm.fengmian_pic = r.avatar
                    })
            },
            handleSelect(key, keyPath) {
                console.log(key, keyPath);
            },
            
            input_sj(e) {
                var t = this
                t.input2 = e
                t.list_data()
                this.data2()
            },
            tishi() {
                this.opens3('请完善店铺信息')
            },
            opens3(eve) {
                this.$message({
                    message: eve,
                    type: 'warning'
                });
            },
            list_price() {
                var t = this
                var url = window.config.api_url + '/college/goods/' + t.$route.params.id
                t.axios.get(url).then(res => {
                    t.lists = res.data,
                        //  = res.data.specification
                        res.data.specification.forEach(function (item) {
                            t.list_guige.push({
                                estimate: item.estimate,
                                goods_id: item.goods_id,
                                id: item.id,
                                price: item.price,
                                specification: item.specification,
                                sum: 0
                            })
                            // console.log(item)
                        })

                    console.log(t.list_guige)
                    t.dp_inform()
                })
            },
            juese() {
                var t = this
                var url = window.config.api_url + '/college/job'
                t.axios.get(url).then(res => {
                    console.log(res)
                    t.qy_juese = res.data
                })
            },
            lingyu() {
                var t = this
                var url = window.config.api_url + '/college/soldier/hotkey'
                t.axios.get(url).then(res => {
                    t.yingyong_ly = res.data
                    console.log(t.yingyong_ly, 98989889989898)
                })
            },
            gj_bujian() {
                var t = this
                var url = window.config.api_url + '/college/goods/parts'
                t.axios.get(url).then(res => {
                    t.lingbujian = res.data
                })
            },
            gy_lian() {
                var t = this
                var url = window.config.api_url + '/college/goods/chain'
                t.axios.get(url).then(res => {
                    t.gongyelian = res.data
                    console.log(t.gongyelian)
                })
            },
            lingyu_sj(e) {
                var t = this
                t.ly_zhi = e
                t.list_data()
            },
            lingyu_sj2(e) {
                var t = this
                t.type = e
                t.list_data()
            },
            juese_sj(e) {
                var t = this
                t.js_zhi = e
                t.list_data()
            },
            bujian_sj(e) {
                var t = this
                t.bujian = e
                t.list_data()
            },
            biaoqian_sc_sj() {
                var t = this
                t.pidzhi = 0
                t.fl_get()
                t.list_data()
            },
            lingyu_sc_sj() {
                var t = this
                t.ly_zhi = ''
                t.list_data()
            },
            lingyu_sc_sj2() {
                var t = this
                t.type = ''
                t.list_data()
            },
            juese_sc_sj() {
                var t = this
                t.js_zhi = ''
                t.list_data()
            },
            bujian_sc_sj() {
                var t = this
                t.bujian = ''
                t.gj_bujian()
                t.list_data()
            },
            fl_get(e) {
                var t = this
                if (e) {
                    t.pidzhi = e.id
                    t.biaoqain_name = e.name
                }
                var url = window.config.api_url + '/college/goods/cate?pid=' + t.pidzhi
                t.axios.get(url).then(res => {
                    if (res.data == '') {

                        return console.log(res.data, 908)
                    }
                    console.log(res.data, 9018)
                    t.qy_juese = res.data
                })
                if (e) {
                    t.list_data()
                }
            },
            list_data(e) {
                var t = this
                var url = window.config.api_url + '/college/soldier/general/list?type=3&paginate=12'
                if (e) {
                    url += '&page=' + e
                } else {
                    url += '&page=1'
                }
                if (t.diqu) {
                    url += '&province=' + t.diqu[0]
                    if (t.diqu[1]) {
                        url += '&city=' + t.diqu[1]
                    }
                    if (t.diqu[2]) {
                        url += '&area=' + t.diqu[2]
                    }
                }
                if (t.bujian) {
                    url += '&parts=' + t.bujian
                }
                if (t.is_open2 == 0) {
                    url += '&order=cash'
                }
                if (t.is_open3 == 0) {
                    url += '&by=desc'
                }
                if (t.is_open3 == 1) {
                    url += '&by=asc'
                }
                if (t.checked == true) {
                    url += '&has_price=1'
                }
                if (t.pidzhi != 0) {
                    url += '&cate_id=' + t.pidzhi
                }
                if (t.ly_zhi) {
                    url += '&title=' + t.ly_zhi.key
                }
                if (t.type) {
                    url += '&type=' + t.type
                }
                if (t.js_zhi) {
                    url += '&aac_id=' + t.js_zhi.id
                }
                if (t.input2) {
                    url += '&title=' + t.input2
                }
                t.axios.get(url).then(res => {
                    t.tab = res.data.data.tags
                    t.list = res.data.data
                    t.zuoshuL = res.data.total
                    t.zuidayema = res.data.last_page
                })
            },
            mm_biaojia() {
                var t = this
                // console.log(1315546)
                t.list_data()
            },
            px_shijian() {
                var t = this
                if (t.is_open2 == 1) {
                    t.is_open2 = 0
                } else {
                    t.is_open2 = 1
                }
                t.list_data()
            },
            px_shijian2() {
                var t = this
                if (t.is_open3 == 1) {
                    t.is_open3 = 0
                } else {
                    t.is_open3 = 1
                }
                t.list_data()
            },
            handleChange(value) {
                this.diqu = value
                this.list_data()
            },
            yedianji(e) {
                this.list_data(e)
            }
        },
        created() {
            this.init()
        }
    }
</script>
<style>
    .el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333 !important;
        margin-bottom: 25px;
        /*line-height: 40px!important;*/
        background-color: #fff;
        width: 265px;
    }

    .el-submenu .el-submenu__title {
        font-size: 18px;
        font-family: Source Han Sans CN;
        /*font-weight: bold;*/
        height: 37px !important;
        color: #FFFFFF !important;
        line-height: 42px !important;
    }

    .el-submenu .el-submenu__title:hover {
        background-color: #4E6EF2 !important;
    }

    .neitong_bufen_qiangzhi .el-tag--light {

        background-color: #4E6EF2 !important;
        color: #FFFFFF !important;
    }

    .neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #4E6EF2;

    }

    .neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #4E6EF2;
    }

    .el-checkbox__inner {
        margin-left: -15px;
    }

    .neitong_bufen_qiangzhi .el-checkbox__input.is-focus .el-checkbox__inner {
        border-color: #666666 !important;
    }

    .neitong_bufen_qiangzhi .el-checkbox__inner:hover {
        border-color: #666666 !important;
    }

    .neitong_bufen_qiangzhi .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #333333 !important;
    }

    .neitong_bufen_qiangzhi .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #4E6EF2 !important;
        border-color: #333333 !important;
    }

    .neitong_bufen_qiangzhi .el-cascader .el-input .el-icon-arrow-down {
        font-size: 0px !important;
        color: #666666 !important;
    }

    .jilian_xuanzeqi_wenzi_yangshi {
        font-size: 18px !important;

    }

    .neitong_bufen_qiangzhi .el-input__inner {
        border: 0px !important;
    }

    .neitong_bufen_qiangzhi .el-tag {
        text-align: center;
        width: 120px;
        margin-top: 20px;
        padding: 0;
        height: 24px;
        line-height: 24px;
        margin-left: 2.5% !important;
    }

    .el-checkbox__label {
        font-size: 18px !important;
    }

    .el-checkbox {

        font-size: 18px !important;
    }
</style>
<style lang="less" scoped>
    @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

    @head_text: Source Han Sans CN;
    @font-face {

    }

    @import "../../../assets/css/home";
    @import "../../../assets/css/home_second_goods";
    .flextext {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        flex: 1;
        flex-basis: auto;
        box-sizing: border-box;
        min-width: 0;
    }
    .jiance_sousuo{
        width: 400px;
    }
    
</style>
